import { useEffect, useRef } from "react";

function usePreviousState(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
export default usePreviousState;